/* gw: predictive search — "view all" footer and no-results message under the dropdown */
(() => {
  const searchUrl = `${window.Shopify.routes.root}search`;

  const decorate = (container) => {
    const input = container.closest('[data-search-container]')?.querySelector('input[data-search]');
    container.querySelectorAll('.gw-search__footer, .gw-search__label').forEach((el) => el.remove());
    const query = input ? input.value.trim() : '';
    if (!query) return;

    const pattern = new RegExp(`(${query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig');
    container.querySelectorAll('.card__title, a.col-12').forEach((el) => {
      const text = el.textContent;
      el.textContent = '';
      text.split(pattern).forEach((part, i) => {
        if (i % 2) {
          const hl = document.createElement('span');
          hl.className = 'gw-search__hl';
          hl.textContent = part;
          el.appendChild(hl);
        } else if (part) {
          el.appendChild(document.createTextNode(part));
        }
      });
    });

    const firstCard = container.querySelector('.card--default');
    if (firstCard) {
      const label = document.createElement('p');
      label.className = 'gw-search__label';
      label.textContent = 'Products';
      (firstCard.closest('[class*="col-"]') || firstCard).before(label);
    }

    const hasResults = container.querySelector('.card--default, a.col-12');
    const footer = document.createElement(hasResults ? 'a' : 'p');
    footer.className = hasResults ? 'gw-search__footer gw-search__all' : 'gw-search__footer gw-search__empty';
    if (hasResults) {
      footer.href = `${searchUrl}?q=${encodeURIComponent(query)}`;
      footer.textContent = `View all results for “${query}”`;
    } else {
      footer.textContent = `No results for “${query}”`;
    }
    container.appendChild(footer);
  };

  const bind = (container) => {
    container.dataset.gwSearchInitd = 'true';
    const observer = new MutationObserver(() => {
      observer.disconnect();
      decorate(container);
      observer.observe(container, { childList: true });
    });
    observer.observe(container, { childList: true });

    const input = container.closest('[data-search-container]')?.querySelector('input[data-search]');
    if (input) input.addEventListener('input', () => setTimeout(() => decorate(container), 600));
  };

  const init = () => document.querySelectorAll('[data-search-suggest]:not([data-gw-search-initd])').forEach(bind);
  init();
  document.addEventListener('booster:content:update', init);
})();
